import type {ReactAction} from '@netx/core/bootstrap';
import {faShare} from '@netx/core-icons';
import {canShareCurrentCart} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Share cart assets
 * @param params
 * @returns Action
 */
export const cartActionShareMenu = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-share-menu',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.MENU),
	enableTest: () => canShareCurrentCart(),
	icon: faShare,
	get label() {
		return CART_CURRENT_ACTION_LABELS.MENU;
	},
	...params,
});

export default cartActionShareMenu;
